import { formatValue } from "../../utils/helpers";
import { DisaggregatedMetric } from "../../services/types";

interface PDFMetricCardProps {
    metric: DisaggregatedMetric;
    width: string;
    disaggData: DisaggregatedMetric[] | null;
    svg?: string;
    showMetadataIcon?: boolean;
};

const PDFMetricCard = ({ metric, svg }: PDFMetricCardProps) => {
    
    // Destructure metric properties
    const { id, name, versions } = metric;
    const { value, unit, unit_descriptor, year, percent_calc } = versions[0];

    let val;
    // We need to manually create the value for ratio, as when the unit type is ratio, value is null
    if (unit === "ratio") {
        val = `${percent_calc?.n}/${percent_calc?.d}`;
    } else val = value;

    return (
        <div className="mx-2 mb-4">
            <div className="flex flex-col items-start w-full">
                <div className="flex items-center justify-start">
                    { svg && <img src={svg} alt={`${name} icon`} className="w-[50px] h-[50px] text-blue-500" /> }
                    
                    <h2 className={`text-lacey-blue text-3xl font-barlow-condensed font-bold ${svg ? 'ml-2' : 'ml-0'}`}>{formatValue(val, unit, id)}</h2>
                </div>
                <div className="flex flex-col my-1">
                    <p className="text-lacey-text text-xs font-bold">{name}</p>
                    {unit_descriptor && <p className={`text-lacey-text text-xs`}>{unit_descriptor}</p>}
                    <p className="text-lacey-text text-xs w-full">in {year}</p>
                </div>
            </div>
        </div>
    );
};


export default PDFMetricCard;
